export enum QueryKeys {
  // Cameras
  GET_CAMERA_SETTINGS = 'GET_CAMERA_SETTINGS',

  // Events
  GET_DEVICE_SUPPORTED_EVENTS = 'GET_DEVICE_SUPPORTED_EVENTS',
  GET_EVENT_METRICS = 'GET_EVENT_METRICS',
  GET_SYSTEM_SUPPORTED_EVENTS = 'GET_SYSTEM_SUPPORTED_EVENTS',

  //delegates
  GET_DELEGATES = 'GET_DELEGATES',
  GET_DELEGATE_GRANTS = 'GET_DELEGATE_GRANTS',

  // vsp
  VSP_IMAGE = 'VSP_IMAGE',

  // AM
  AM_IMAGE = 'AM_IMAGE',

  // media
  GET_RECORDED_IMAGE = 'GET_RECORDED_IMAGE',

  // application links
  GET_APPLICATION_LINKS = 'GET_APPLICATION_LINKS',

  // idP group assingments
  GET_PAGINATED_IDP_GROUP_ASSIGNMENTS = 'GET_PAGINATED_IDP_GROUP_ASSIGNMENTS',
  GET_ALL_IDP_GROUP_ASSIGNMENTS = 'GET_ALL_IDP_GROUP_ASSIGNMENTS',

  // idP groups
  GET_ALL_IDP_GROUPS = 'GET_ALL_IDP_GROUPS',
  GET_PAGINATED_IDP_GROUPS = 'GET_PAGINATED_IDP_GROUPS',

  //Io ports
  GET_IO_PORTS = 'GET_IO_PORTS',
  GET_RECORDING_ACTION_CAMERAS = 'GET_RECORDING_ACTION_CAMERAS',
  GET_RECORDING_ACTION_CAMERA = 'GET_RECORDING_ACTION_CAMERA',
  GET_IO_PORT = 'GET_IO_PORT',
}
